export const ADD_INVESTMENT_REQUEST = "ADD_INVESTMENT_REQUEST";
export const ADD_INVESTMENT_SUCCESS = "ADD_INVESTMENT_SUCCESS";
export const ADD_INVESTMENT_FAIL = "ADD_INVESTMENT_FAIL";
export const ADD_INVESTMENT_RESET = "ADD_INVESTMENT_RESET";

export const GET_INVESTMENT_REQUEST = "GET_INVESTMENT_REQUEST";
export const GET_INVESTMENT_SUCCESS = "GET_INVESTMENT_SUCCESS";
export const GET_INVESTMENT_FAIL = "GET_INVESTMENT_FAIL";

export const DELETE_INVESTMENT_REQUEST = "DELETE_INVESTMENT_REQUEST";
export const DELETE_INVESTMENT_SUCCESS = "DELETE_INVESTMENT_SUCCESS";
export const DELETE_INVESTMENT_FAIL = "DELETE_INVESTMENT_FAIL";
export const DELETE_INVESTMENT_RESET = "DELETE_INVESTMENT_RESET";

export const UPDATE_INVESTMENT_REQUEST = "UPDATE_INVESTMENT_REQUEST";
export const UPDATE_INVESTMENT_SUCCESS = "UPDATE_INVESTMENT_SUCCESS";
export const UPDATE_INVESTMENT_FAIL = "UPDATE_INVESTMENT_FAIL";
export const UPDATE_INVESTMENT_RESET = "UPDATE_INVESTMENT_RESET";

export const CLEAR_ERRORS = "CLEAR_ERRORS"; 